export const LANGUAGES = {
  'en-US': 'English',
  'es-ES': 'Español',
  'ru-RU': 'Русский',
  'pt-PT': 'Português'
}
